module.exports = __webpack_public_path__ + "static/media/dice-icon.61e2757a.svg";